
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface IConfig {
  [key: string]: any;
  environmentName: string;
  clientSecret: string;
  backendPortalUri: string;
  backendIwmUri: string;
  accountBaseUri: string;
  portalBaseUri: string;
  productApiKey: string;
  applicationInsightsConnectionString: string;
  applicationInsightsInstrumentationKey: string; // To be removed. Do not use.
}

@Injectable({
  providedIn: 'root'
})
export class AppConfig {

  private config: IConfig;

  constructor(private http: HttpClient) { }

  get environmentName(): string {
    return this.getConfig('environmentName');
  }
  get productId(): number {
    return Number(this.getConfig('productId'));
  }
  get iwdProductId(): number {
    return Number(this.getConfig('iwdProductId'));
  }
  get IWMTenderingId(): number {
    return Number(this.getConfig('IWMTenderingId'));
  }
  get iwmSatNetProductId(): number {
    return Number(this.getConfig('iwmSatNetProductId'));
  }
  get iwmTaxReportingId(): number {
    return Number(this.getConfig('iwmTaxReportingId'));
  }
  get iwmPlanBudgetingId(): number {
    return Number(this.getConfig('iwmPlanBudgetingId'));
  }
  get IWMDNACustomizationsId(): number {
    return Number(this.getConfig('IWMDNACustomizationsId'));
  }
  get iwmExternalUnitImportId(): number {
    return Number(this.getConfig('iwmExternalUnitImportId'));
  }
  get iwmEndCustomerInvoicingId(): number {
    return Number(this.getConfig('iwmEndCustomerInvoiceId'));
  }
  get iwmExternalAreaImportId(): number {
    return Number(this.getConfig('iwmExternalAreaImportId'));
  }
  get iwmEndCustomerInvoiceId(): number {
    return Number(this.getConfig('iwmEndCustomerInvoiceId'));
  }
  get iwmInventoryProductId(): number {
    return Number(this.getConfig('iwmInventoryProductId'));
  }
  get iwmLoistePurchaseOrderProductId(): number {
    return Number(this.getConfig('IWMLoistePurchaseOrderProductId'));
  }
  get orderingApprovalProductId(): number {
    return Number(this.getConfig('orderingApprovalProductId'));
  }
  get invoicingProposalAcceptanceLimitId(): number {
    return Number(this.getConfig('InvoicingProposalAcceptanceLimitId'));
  }
  get twoStepApprovalProcessId(): number {
    return Number(this.getConfig('iwmTwoStepApprovalProcessId'));
  }
  get deputyFeatureProductId(): number {
    return Number(this.getConfig('deputyFeatureProductId'));
  }
  get clientSecret(): string {
    return this.getConfig('clientSecret');
  }
  get applicationInsightsConnectionString(): string {
    return this.getConfig('applicationInsightsConnectionString');
  }
  /**
    * Deprecated. Do not use. Use applicationInsightsConnectionString instead.
    */
  get applicationInsightsInstrumentationKey(): string {
    return this.getConfig('applicationInsightsInstrumentationKey');
  }
  get backendPortalUri(): string {
    return this.getConfig('backendPortalUri');
  }
  get backendAccountUri(): string {
    return this.getConfig('backendAccountUri');
  }
  get backendExternalContactUri(): string {
    return this.getConfig('backendExternalContactUri');
  }
  get backendMessageUri(): string {
    return this.getConfig('backendMessageUri');
  }
  get backendMapUri(): string {
    return this.getConfig('backendMapUri');
  }
  get backendPortalUsersUri(): string {
    return this.getConfig('backendPortalUsersUri');
  }
  get backendIwmUri(): string {
    return this.getConfig('backendIwmUri');
  }
  get backendIwmPOCUri(): string {
    return this.getConfig('backendIwmPOCUri');
  }
  get backendAmgUri(): string {
    return this.getConfig('backendAmgUri');
  }
  get accountBaseUri(): string {
    return this.getConfig('accountBaseUri');
  }
  get portalBaseUri(): string {
    return this.getConfig('portalBaseUri');
  }
  get geoBaseUri(): string {
    return this.getConfig('geoBaseUri');
  }
  get productApiKey(): string {
    return this.getConfig('productApiKey');
  }
  get dipoBackendUri(): string {
    return this.getConfig('dipoBackendUri');
  }
  get amgPortalEndpoint(): string {
    return this.getConfig('amgPortalEndpoint');
  }
  get iwdPortalEndpoint(): string {
    return this.getConfig('iwdPortalEndpoint');
  }
  get iwmPortalEndpoint(): string {
    return this.getConfig('iwmPortalEndpoint');
  }
  get maastoUri(): string {
    return this.getConfig('maastoUri');
  }

  get structurePlanUri(): string {
    return this.getConfig('structurePlanUri');
  }

  get backendAiUri(): string {
    return this.getConfig('backendAiUri');
  }

  /**
   * Use to get the data found in the config file
   * @param key Configuration key
   * @returns Configuration value
   */
  public getConfig(key: any): string {
    return this.config[key];
  }

  /**
   * Returns config object
   * @returns Config object
   */
  public getAll(): any {
    return this.config;
  }

  /**
   * This method loads "config.json" to get all env's variables
   */
  public load(appVersion?: string): Promise<any> {
    let configUrl = 'config/config.json';

    if (appVersion) {
      configUrl += `?v=${appVersion}`;
    }

    return new Promise((resolve, reject) => {
      this.http.get<IConfig>(configUrl)
        .pipe(
          catchError((error: any) => {
            console.error('Error reading config/config.json configuration file');
            resolve(error);
            return throwError(() => error?.json()?.error || 'Server error');
          }))
        .subscribe(result => {
          this.config = result;
          resolve(true);
        });
    });
  }
}
